<template>
	<div class="">
		<div class="login-box">
			<h1 class="fz-24 yx-pingfang-Medium">{{ title }}</h1>
			<form>
				<div class="mt-32">
					<input type="text" hidden autocomplete="username" />
					<input type="password" hidden autocomplete="new-password" />
					<div :class="error.mobile ? 'error' : ''">
						<el-input type="text" placeholder="请输入11位手机号" size="medium" maxlength="11" v-model.trim="settingInfo.mobile" clearable>
							<i class="i-mobile" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.mobile }}</p>
						</div>
					</div>
					<div :class="error.sms_code ? 'error' : ''">
						<div class="flex-row">
							<span class="special">
								<el-input type="text" placeholder="请输入验证码" size="medium" v-model="settingInfo.sms_code" clearable></el-input>
							</span>
							<el-button type="primary" plain class="ml-12 flex-1" size="medium" @click="clickSendCode" :disabled="!!sendCodeTimeText">
								{{ sendCodeTimeText ? sendCodeTimeText : sendCodeText }}
							</el-button>
						</div>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.sms_code }}</p>
						</div>
					</div>
					<div :class="error.password ? 'error' : ''">
						<el-input
							:type="pwdType ? 'password' : 'text'"
							placeholder="请输入6-16位密码, 区分大小写"
							size="medium"
							v-model="settingInfo.password"
							:class="pwdType && settingInfo.password ? 'special-pwd' : ''"
						>
							<i class="i-pwd" slot="prefix"></i>
							<i class="cursor-pointer" :class="pwdType ? 'i-eye-close' : 'i-eye-open'" slot="suffix" @click="changePwdType"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.password }}</p>
						</div>
					</div>
					<div :class="error.repeat_password ? 'error' : ''">
						<el-input
							:type="repPwdType ? 'password' : 'text'"
							placeholder="确认密码"
							size="medium"
							v-model="settingInfo.repeat_password"
							:class="repPwdType && settingInfo.repeat_password ? 'special-pwd' : ''"
						>
							<i class="i-pwd" slot="prefix"></i>
							<i class="cursor-pointer" :class="repPwdType ? 'i-eye-close' : 'i-eye-open'" slot="suffix" @click="changeRepPwdType"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.repeat_password }}</p>
						</div>
					</div>
					<div class="flex-row mt-12" style="height: 48px">
						<el-button type="primary" size="medium" class="flex-1" :disabled="!canLogin" @click="clickSetting" :loading="loading">确定</el-button>
					</div>
					<div class="flex-row-align-center font-h4-regular yx-color-primary mt-16">
						<el-button type="text" @click="goLogin">直接登录</el-button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import { sendCode, setPassword } from '@/api/user';
import { isValidPassword, isTel } from '@/utils/reg';
import md5 from 'js-md5';
export default {
	data() {
		return {
			settingInfo: {
				mobile: '',
				sms_code: '',
				password: '',
				repeat_password: '',
			},
			error: {
				mobile: '',
				sms_code: '',
				password: '',
				repeat_password: '',
			},
			sendCodeText: '获取验证码',
			sendCodeTime: '',
			timer: null,
			pwdType: true,
			repPwdType: true,
			canLogin: false,
			loading: false,
		};
	},
	props: {
		title: {
			type: String,
			default: () => '设置密码',
		},
		mobile: {
			type: String,
			default: () => '',
		},
	},
	computed: {
		sendCodeTimeText() {
			return this.sendCodeTime ? this.sendCodeTime + 's' : '';
		},
	},
	created() {
		this.settingInfo.mobile = this.mobile;
	},
	watch: {
		settingInfo: {
			handler() {
				this.canLogin = this.validData();
			},
			deep: true,
		},
	},
	methods: {
		validData() {
			if (this.settingInfo.mobile && this.settingInfo.sms_code && this.settingInfo.password && this.settingInfo.repeat_password) {
				return true;
			}
			return false;
		},
		validSettingInfo() {
			if (!this.settingInfo.mobile) {
				this.error.mobile = '请输入手机号';
			} else if (!isTel.test(this.settingInfo.mobile)) {
				this.error.mobile = '手机号输入错误';
			} else {
				this.error.mobile = '';
			}
			if (!this.settingInfo.sms_code) {
				this.error.sms_code = '请输入验证码';
			} else {
				this.error.sms_code = '';
			}
			if (!this.settingInfo.password) {
				this.error.password = '请输入密码';
			} else if (this.settingInfo.password.length < 6 || this.settingInfo.password.length > 16) {
				this.error.password = '请输入6~16位密码,区分大小写';
			} else {
				this.error.password = '';
			}
			if (!this.settingInfo.repeat_password) {
				this.error.repeat_password = '请输入确认密码';
			} else if (this.settingInfo.repeat_password !== this.settingInfo.password) {
				this.error.repeat_password = '两次的密码输入不相同';
			} else {
				this.error.repeat_password = '';
			}
			if (this.agreeRule == 0) {
				this.$message.warning('请勾选同意《央选联盟平台使用条款》和《央选隐私协议》');
				return false;
			}
			// 判断是否存在输入错误，没有错误返回true，有错误返回false
			if (this.error.mobile || this.error.sms_code || this.error.password || this.error.repeat_password) {
				return false;
			}
			return true;
		},
		clickSendCode() {
			if (!this.settingInfo.mobile) {
				this.$message.error('请输入手机号');
				return;
			}
			if (!isTel.test(this.settingInfo.mobile)) {
				this.$message.error('手机号输入错误');
				return;
			}
			const params = {
				mobile: this.settingInfo.mobile,
			};
			sendCode(params)
				.then(res => {
					if (res.code === 0) {
						// 短信验证码发送成功
						this.sendCodeTime = 60;
						this.startTimer();
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(e => {
					this.$message.error(e.message);
				});
		},
		clearTimer() {
			clearInterval(this.timer);
			this.timer = null;
		},
		startTimer() {
			if (this.timer) {
				// 倒计时存在的时候，不要重复开启
				return;
			}
			this.timer = setInterval(() => {
				this.sendCodeTime--;
				if (this.sendCodeTime <= 0) {
					this.clearTimer();
				}
			}, 1000);
		},
		goLogin() {
			this.$emit('goLogin');
		},
		async clickSetting() {
			this.loading = true;
			const valid = this.validSettingInfo();
			if (!valid) {
				this.loading = false;
				return;
			}
			let params = JSON.parse(JSON.stringify(this.settingInfo));
			params.password = md5(this.settingInfo.password);
			params.repeat_password = md5(this.settingInfo.repeat_password);
			const { code } = await setPassword(params);
			if (code === 0) {
				this.$message.success('重置密码成功');
				this.$emit('goLogin');
			}
			this.loading = false;
		},
		changePwdType() {
			this.pwdType = !this.pwdType;
		},
		changeRepPwdType() {
			this.repPwdType = !this.repPwdType;
		},
	},
};
</script>
<style lang="less" scoped>
@import '@/styles/login.less';
</style>
